import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DemoService } from 'src/app/services/common/demo.service';
import { BotAssistenzaService, MessaggioChat } from 'src/app/services/common/bot-assistenza.service';
import { DemoFlowService } from 'src/app/services/common/demo-flow.service';

/**
 * Chat con l'assistente dentro la demo pubblica: pulsante in basso a destra e
 * pannello che si apre sopra.
 *
 * Parte aperta. Chi arriva da /demo ha appena chattato sulla landing: trovare
 * la conversazione già lì, invece di un pulsante da scoprire, è la
 * continuazione naturale dell'onboarding. Chiudendola resta il pulsante.
 *
 * Come il giro guidato, vive nel guscio dell'applicazione e non in una
 * pagina: deve restare in piedi mentre l'utente cambia sezione.
 */
@Component({
  selector: 'app-demo-chat',
  templateUrl: './demo-chat.component.html',
  styleUrls: ['./demo-chat.component.scss']
})
export class DemoChatComponent implements OnInit, OnDestroy {

  @ViewChild('flusso') flusso: ElementRef<HTMLElement>;

  attiva = false;
  aperta = true;
  private fineDemo: Subscription;

  messaggi: MessaggioChat[] = [];
  testo = '';
  botPensa = false;

  constructor(
    private cd: ChangeDetectorRef,
    private bot: BotAssistenzaService,
    private demoFlow: DemoFlowService
  ){}

  async ngOnInit(){
    // La demo può finire mentre la chat è già in piedi: succede a chi si
    // registra dallo stepper e rientra nel portale col suo account.
    this.fineDemo = DemoService.chiusa.subscribe(() => {
      this.attiva = false;
      this.aperta = false;
      this.cd.detectChanges();
    });
    if(!DemoService.active) return;
    this.attiva = true;
    try{
      // Se il visitatore ha già scritto sul sito, la conversazione riprende
      // da dove era: stesso id_browser fra landing e demo.
      const conv = await this.bot.conversazione();
      if(conv.messaggi.length) this.messaggi = conv.messaggi;
    }catch(err){
      console.error(err);
    }
    if(!this.messaggi.length){
      this.messaggi = [{ da: 'bot', testo: 'Ciao! Sono l\'assistente di Balin 👋 Guarda pure la demo con calma: se hai una domanda scrivimi qui.' }];
    }
    this.cd.detectChanges();
    this.inFondo();
  }

  ngOnDestroy(){
    this.fineDemo?.unsubscribe();
  }

  apri(){ this.aperta = true; this.cd.detectChanges(); this.inFondo(); }
  chiudi(){ this.aperta = false; this.cd.detectChanges(); }

  /** "🧭 Tour guidato": lo fa ripartire chi lo sa fare, cioè app-demo-tour. */
  chiediTour(){
    this.chiudi();
    this.demoFlow.chiediTour();
  }

  /** "🚀 Prova gratuita": la stessa pagina della CTA in barra. */
  apriProva(){
    this.chiudi();
    this.demoFlow.vaiAllaRichiestaProva();
  }

  async manda(){
    const t = (this.testo || '').trim();
    if(!t || this.botPensa) return;
    this.messaggi.push({ da: 'io', testo: t });
    this.testo = '';
    this.botPensa = true;
    this.cd.detectChanges();
    this.inFondo();

    const esito = await this.bot.invia(t);
    this.botPensa = false;
    if(esito.risposta) this.messaggi.push({ da: 'bot', testo: esito.risposta });
    else if(esito.passatoAOperatore) this.messaggi.push({ da: 'sistema', testo: 'Conversazione in mano a un operatore (' + esito.passatoAOperatore + ').' });
    else if(esito.errore) this.messaggi.push({ da: 'sistema', testo: esito.errore });
    if(esito.troncata) this.messaggi.push({ da: 'sistema', testo: 'Attenzione: la risposta è stata troncata.' });
    this.cd.detectChanges();
    this.inFondo();
  }

  /** L'ultimo messaggio deve essere visibile, altrimenti la risposta del bot
   *  arriva e nessuno se ne accorge. */
  private inFondo(){
    setTimeout(() => {
      const el = this.flusso?.nativeElement;
      if(el) el.scrollTop = el.scrollHeight;
    }, 30);
  }
}
